import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as approvalApi from '../../lib/api/approval';

const [
  LIST_APPROVAL_MONITOR,
  LIST_APPROVAL_MONITOR_SUCCESS,
  LIST_APPROVAL_MONITOR_FAILURE,
] = createRequestActionTypes('approval/LIST_APPROVAL_MONITOR');
export const listApprovalMonitor = createAction(
  LIST_APPROVAL_MONITOR,
  (searchData) => ({ searchData }),
);
const listApprovalsSaga = createRequestSaga(
  LIST_APPROVAL_MONITOR,
  approvalApi.getApprovalMonitor,
);

const UNLOAD_APPROVAL_MONITOR = 'approval/UNLOAD_APPROVAL_MONITOR';
export const unloadApprovalMonitor = createAction(UNLOAD_APPROVAL_MONITOR);

export function* approvalMonitorSaga() {
  yield takeLatest(LIST_APPROVAL_MONITOR, listApprovalsSaga);
}

const initialState = {
  approvals: null,
  error: null,
};

const approvalMonitor = handleActions(
  {
    [LIST_APPROVAL_MONITOR_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      approvals: data.info.map((approval) => ({
        id: approval.DOCU_UUID,
        apprUuid: approval.APPR_UUID,
        docuUuid: approval.DOCU_UUID,
        docuTyp: approval.DOCY_TYP,
        partnerInc: approval.PARTNER_INC,
        cstNm: approval.CST_NM,
        docuNo: approval.DOCU_NO,
        docuCd: approval.DOCU_CD,
        docuStep: approval.DOCU_STEP,
        docuUsr: approval.DOCU_USR,
        USR_DATA: approval.USR_DATA,
        // docuUsrNm: approval.DOCU_USR_NM,
        // docuUsrProfile: approval.DOCU_USR_PROFILE,
        // docuUsrDptNm: approval.DOCU_DT,
        // docuUsrGradeNm: approval.GRADE_NM,
        docuYn: approval.DOCU_YN,
        docuTxt: approval.DOCU_TXT,
        docuCnt: approval.DOCU_CNT, //총 결재단계
        docuNow: approval.DOCU_NOW, //현재 단계
        docuNowUsr: approval.DOCU_NOW_USR, //현재 단계 결재자
        docuStatus: approval.DOCU_STATUS,
        crtUsr: approval.CRT_USR,
        crtNm: approval.CRT_NM,
        crtDt: approval.CRT_DT,
      })),
      error: null,
    }),
    [LIST_APPROVAL_MONITOR_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_APPROVAL_MONITOR]: () => initialState,
  },
  initialState,
);

export default approvalMonitor;
